(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tryndi-bestsellers-tabs"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTryndiBestsellers(root) {

    if (!root) return;

    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');

    if (!tabs.length || !panels.length) return;


    function activateTab(tabId) {

      tabs.forEach(function (tab) {

        const active = tab.dataset.tab === tabId;

        tab.classList.toggle('is-active', active);

        tab.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

      });


      panels.forEach(function (panel) {

        const active = panel.dataset.panel === tabId;

        panel.classList.toggle('is-active', active);

        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }

      });

    }


    tabs.forEach(function (tab) {

      if (tab.dataset.tryndiBound === 'true') return;

      tab.dataset.tryndiBound = 'true';

      tab.addEventListener('click', function () {

        activateTab(tab.dataset.tab);

      });

    });


    root.tryndiActivateTab = activateTab;

  }



  function initAllTryndiBestsellers(container) {

    const scope = container || document;

    if (
      scope.matches &&
      scope.matches('[data-tryndi-bestsellers]')
    ) {
      initTryndiBestsellers(scope);
    }

    if (scope.querySelectorAll) {

      scope
        .querySelectorAll('[data-tryndi-bestsellers]')
        .forEach(initTryndiBestsellers);

    }

  }



  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllTryndiBestsellers(document);
      }
    );

  } else {

    initAllTryndiBestsellers(document);

  }



  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllTryndiBestsellers(event.target);

    }
  );



  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const blockId = event.detail && event.detail.blockId;

      if (!blockId) return;

      const tab = document.querySelector(
        '[data-tryndi-bestsellers] [data-block-id="' + blockId + '"]'
      );

      if (!tab) return;

      const root = tab.closest('[data-tryndi-bestsellers]');

      if (
        root &&
        typeof root.tryndiActivateTab === 'function'
      ) {

        root.tryndiActivateTab(tab.dataset.tab);

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
